const BUILD_ENV = {
  REACT_APP_NODE_ENV: process.env.REACT_APP_NODE_ENV,
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_STORAGE_BASE_URL: process.env.REACT_APP_STORAGE_BASE_URL,
  REACT_APP_UTILS_BASE_URL: process.env.REACT_APP_UTILS_BASE_URL,
  REACT_APP_POLICY_BASE_URL: process.env.REACT_APP_POLICY_BASE_URL,
  REACT_APP_WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL,
  REACT_APP_PREVIEW_UI_TEMPLATE: process.env.REACT_APP_PREVIEW_UI_TEMPLATE,
  REACT_APP_PREVIEW_BACKEND_TEMPLATE: process.env.REACT_APP_PREVIEW_BACKEND_TEMPLATE,
  REACT_APP_PREVIEW_BACKEND_API_TEMPLATE: process.env.REACT_APP_PREVIEW_BACKEND_API_TEMPLATE,
  REACT_APP_PREVIEW_DATABASE_TEMPLATE: process.env.REACT_APP_PREVIEW_DATABASE_TEMPLATE,
  REACT_APP_SOURCE_SYNC: process.env.REACT_APP_SOURCE_SYNC,
  REACT_APP_AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
  REACT_APP_AUTH0_CLIENTID: process.env.REACT_APP_AUTH0_CLIENTID,
  REACT_APP_AUTH0_MS_CONNECTION: process.env.REACT_APP_AUTH0_MS_CONNECTION,
  REACT_APP_AUTH0_GCP_CONNECTION: process.env.REACT_APP_AUTH0_GCP_CONNECTION,
  REACT_APP_VERSION: process.env.REACT_APP_VERSION,
  REACT_APP_RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  REACT_APP_CAPTCHA_VISIBLE: process.env.REACT_APP_CAPTCHA_VISIBLE,
  REACT_APP_AZURE_CLIENT_ID: process.env.REACT_APP_AZURE_CLIENT_ID,
  REACT_APP_LOCAL_STORAGE_PATH: process.env.REACT_APP_LOCAL_STORAGE_PATH,
  REACT_APP_DEFAULT_PREVIEW_URL: process.env.REACT_APP_DEFAULT_PREVIEW_URL,
};

export const getEnv = (key, fallback = "") => {
  if (typeof window !== "undefined" && window.__ENV__ && window.__ENV__[key] != null && window.__ENV__[key] !== "") {
    return window.__ENV__[key];
  }
  const built = BUILD_ENV[key];
  if (built != null && built !== "") return built;
  return fallback;
};
